import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { Subscription } from 'rxjs/Subscription';
import { ContractService } from '../../services/contract.service';
import { LogService } from '../../services/shared/log.service';
import { NGaugeService } from '../../services/shared/ngauge.service';
import { UserService } from '../../services/user.service';
import { FilterDialogModalComponent } from '../../shared-components/filter-dialog-modal/filter-dialog-modal.component';
import { MODEL_FIELDS } from '../../shared/search-filter-fields';
import { LOG_LEVELS, LOG_MESSAGES, PDF_PRE_TEXT } from '../../util/constants';
import { DateUtil } from '../../util/dateUtil';
import { AuthService } from '../../services/shared/auth.service';
declare let HelloSign: any;

@Component({
  selector: 'app-contracts',
  templateUrl: './contracts.component.html',
  styleUrls: ['./contracts.component.scss']
})
export class ContractsComponent implements OnInit, OnDestroy {

  @Input() documentDefinition: any;
  @Input() groupId: any;
  @Input() documentId: any;
  @Input() groupAgreementAccountId: any;
  @Input() cancellationDetails: any;
  @Input() docFrom: any;
  @Input() docType: any;
  @Output() mailPDF = new EventEmitter<boolean>();
  signRequestDetails: any;
  statusCount: any;
  base64Image: any;
  statusInfo: any;
  pdfDocument: any;
  newDocumentDefinition: any;
  cancelledText = '';
  downloadContractSubscription: Subscription;
  statusSubscription: Subscription;
  dialogCloseSubscription: Subscription;
  sendNotifySubscription: Subscription;
  sendSignRequestSubscription: Subscription;
  cancelRequestSubscription: Subscription;
  updateSignRequestSubscription: Subscription;
  createContractSignSubscription: Subscription;

  constructor(
    private contractService: ContractService,
    private ngaugeService: NGaugeService,
    private userService: UserService,
    private dialog: MatDialog,
    private authservice:AuthService,
    private logService: LogService) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
  }

  async ngOnInit() {
    this.newDocumentDefinition = JSON.parse(JSON.stringify(this.documentDefinition));
    this.base64Image = await this.getBase64Image(this.documentDefinition);
    this.getViewStatus(this.groupId);
  }

  getBase64Image(definition: any): Promise<any> {
    return new Promise(resolve => {
      this.pdfDocument = pdfMake.createPdf(definition);
      this.pdfDocument.getBase64((base64: any) => {
        resolve(`data:application/pdf;base64,${base64}`);
      });
    });
  }

  getViewStatus(id) {
    this.statusCount = {
      unviewed: 0,
      viewed: 0,
      signed: 0
    };
    this.statusSubscription = this.contractService.getAgreementViewStatus(id, this.docType, this.documentId).subscribe((res: any) => {
      if (res.result.signature_request) {
        this.signRequestDetails = res.result;
        this.statusInfo = res.result.signature_request.signatures;
        this.statusInfo.forEach(status => {
          status.remindedOn = status.last_reminded_at !== null ?
            DateUtil.getDateInMMDDYYYYTime(this.contractService.convertEpochDate(status.last_reminded_at)) : '';
          if (status.signed_at !== null) {
            status = this.getUIElements(status, status.signed_at, status.signer_name, 'signed', 'verified_user',
              'signed-icon', 'label-box signed-label-box');
            this.statusCount.signed++;
          } else if (status.last_viewed_at !== null) {
            status = this.getUIElements(status, status.last_viewed_at, status.signer_name, 'viewed', 'visibility',
              'viewed-icon', 'label-box viewed-label-box');
            this.statusCount.viewed++;
          } else {
            status = this.getUIElements(status, null, status.signer_name, 'Not Viewed', 'visibility_off',
              'unviewed-icon', 'label-box unviewed-label-box');
            this.statusCount.unviewed++;
          }
          if (status.status_code === 'declined') {
            this.cancelledText = 'Agreement was declined by ' + status.signer_name;
          }
        });
        this.documentDefinition = this.ngaugeService.isJSON(this.signRequestDetails.reportDetails.contractImage);
      }
    }, error => {
      this.logService.logError(LOG_LEVELS.ERROR, this.docFrom + 'Doc', 'On fetch Agreement status', JSON.stringify(error));
    });
  }

  getUIElements(status, updated, name, signStatus, icon, color, classes) {
    status['updated'] = updated !== null ?
      DateUtil.getDateInMMDDYYYYTime(this.contractService.convertEpochDate(updated)) : '';
    const str = name;
    const matches = str.match(/\b(\w)/g);
    status['label'] = matches.join('');
    status['statusValue'] = signStatus;
    status['icon'] = icon;
    status['color'] = color;
    status['class'] = classes;
    return status;
  }

  downloadDoc() {
    this.pdfDocument.download(this.docFrom + '.pdf');
    this.logUserActivity(this.docFrom + '- Download', LOG_MESSAGES.CLICK);
  }

  viewPDF() {
    this.pdfDocument.open();
    this.logUserActivity(this.docFrom + '- Open In New Tab', LOG_MESSAGES.CLICK);
  }

  printDoc() {
    this.pdfDocument.print();
    this.logUserActivity(this.docFrom + '- Pring Doc', LOG_MESSAGES.CLICK);
  }

  downloadContract(requestId) {
    this.logUserActivity(this.docFrom + '- Download Final Copy', LOG_MESSAGES.CLICK);
    this.downloadContractSubscription = this.contractService.downloadContract(requestId, 'completed').subscribe((res: any) => {
      this.ngaugeService.downloadPDF(PDF_PRE_TEXT + res.result.$data, this.docFrom);
    }, error => {
      this.logService.logError(LOG_LEVELS.ERROR, this.docFrom + 'Doc', 'On Downloading final Copy', JSON.stringify(error));
    });
  }

  downloadManualContract() {
    const definition = this.ngaugeService.isJSON(this.signRequestDetails.reportDetails.contractImage);
    const pdfDocument = pdfMake.createPdf(definition);
    pdfDocument.getBase64((base64: any) => {
      this.ngaugeService.downloadPDF(PDF_PRE_TEXT + base64, this.docFrom);
    });
  }

  async sendSignrequest(result, groupDetails, isCancelled) {
    result.base64 = this.base64Image;
    const gDetails = JSON.parse(JSON.stringify(groupDetails));
    delete groupDetails.reason;
    groupDetails.contractImage = JSON.stringify(this.newDocumentDefinition);
    groupDetails.property = this.userService.getLoggedInUserProperty();
    result.requester_email_address = this.userService.getLoggedInEmail();
    this.sendSignRequestSubscription =
      this.contractService.getClaimUrl(result).subscribe((res: any) => {
        const status = isCancelled ? 'resend' : 'created';
        if (res['result']['unclaimed_draft']) {
          const client = new HelloSign();
          const signRequestId = res.result.unclaimed_draft.signature_request_id;
          client.open(res.result.unclaimed_draft.claim_url, {
            clientId: res.result.clientId,
            skipDomainVerification: true
          });
          client.on('finish', () => {
            groupDetails.signRequestId = signRequestId;
            this.createContractSignSubscription =
              this.contractService.sendPdf(groupDetails).subscribe(async (resp: any) => {
                if (isCancelled) {
                  const definition = {
                    watermark: 'INVALID',
                    content: this.newDocumentDefinition.content,
                    styles: this.newDocumentDefinition.styles
                  };
                  const updateDetails = {
                    reason: gDetails['reason'],
                    contractImage: JSON.stringify(definition),
                    contractLog: JSON.stringify(this.statusInfo),
                    id: this.signRequestDetails.reportDetails.id
                  };
                  await this.updateSignRequestDetails(updateDetails, false, false);
                }
                this.getViewStatus(resp.result.reportId);
              });
            this.ngaugeService.toastrSuccess('Sign-Request ' + status + ' successfully');
          });
        } else {
          this.ngaugeService.toastrError('Sign Request ' + status + ' Failed');
          this.logService.logError(LOG_LEVELS.DEBUG, this.docFrom + 'Doc', 'On Sending Sign Request',
            JSON.stringify(groupDetails));
        }
      }, error => {
        this.logService.logError(LOG_LEVELS.ERROR, this.docFrom + 'Doc', 'On Sending Sign Request',
          JSON.stringify(error));
      });
  }

  cancelSignRequest(requestId,emailID, isCancelled): Promise<void> {
    return new Promise(resolve => {
      this.cancelRequestSubscription =
        this.contractService.cancelRequest(requestId,emailID).subscribe((res: any) => {
          if (!res.result) {
            this.logService.logError(LOG_LEVELS.DEBUG, this.cancellationDetails.accountName + ' - ' +
              this.cancellationDetails.docName, 'On Cancel Sign Request', JSON.stringify({ RequestId: requestId }));
          } else {
            this.statusCount = {
              unviewed: 0,
              viewed: 0,
              signed: 0
            };
            if (isCancelled) {
              this.ngaugeService.toastrSuccess('Sign Request Cancelled Successfully');
            }
          }
          resolve();
        }, error => {
          resolve();
          if (isCancelled) {
            this.ngaugeService.toastrError('Sign Request Cancel Failed');
          }
          this.logService.logError(LOG_LEVELS.ERROR, this.cancellationDetails.accountName + ' - ' +
            this.cancellationDetails.docName, 'On Cancel Sign Request', JSON.stringify(error));
        });
    });
  }

  sendNotification(value) {
    this.logUserActivity(this.docFrom + '- Send Reminder', LOG_MESSAGES.CLICK);
    const findSign = this.signRequestDetails.signature_request.signatures.findIndex(sign =>
      sign.signer_email_address === value.signer_email_address);
    let allsigned = true;
    let notSignedUser: any;
    if (findSign > 0) {
      signer: for (let i = 0; i < findSign; i++) {
        if (this.signRequestDetails.signature_request.signatures[i].signed_at === null) {
          notSignedUser = i;
          allsigned = false;
          break signer;
        }
      }
    }
    if (allsigned) {
      const param = {
        requestId: this.signRequestDetails.signature_request.signature_request_id,
        mailId: value.signer_email_address
      };
      this.sendNotifySubscription = this.contractService.sendNotification(param).subscribe(res => {
        if (res['result']) {
          this.getViewStatus(this.groupId);
          this.ngaugeService.toastrSuccess('Notification send successfully');
        } else {
          this.ngaugeService.toastrError('Notification can send once in an hour');
          this.logService.logError(LOG_LEVELS.DEBUG, this.docFrom + 'Doc', 'On Sending Reminder', JSON.stringify(param));
        }
      }, error => {
        this.ngaugeService.toastrError('Notification can send once in an hour');
        this.logService.logError(LOG_LEVELS.ERROR, this.docFrom + 'Doc', 'On Sending Reminder', JSON.stringify(error));
      });
    } else {
      this.ngaugeService.toastrInfo('Now ' +
        this.signRequestDetails.signature_request.signatures[notSignedUser].signer_name + '\'s turn to sign');
    }
  }

  cancel() {
    const formFields = MODEL_FIELDS.FILTER_USING_TEXT_FIELD;
    const dialogRef = this.dialog.open(FilterDialogModalComponent, {
      width: formFields.length === 1 ? '415px' : '507px',
      height: 'auto',
      data: {
        accept: 'Yes, Cancel it', reject: 'No',
        modalTitle: 'Reason For Cancel', formFields,
        description: 'Enter the reason for cancelling the SignRequest'
      }
    });
    this.logUserActivity(this.cancellationDetails.from + ' - Cancel', LOG_MESSAGES.CLICK);
    this.dialogCloseSubscription = dialogRef.afterClosed().subscribe(async result => {
      if (result !== undefined) {
        const definition = {
          watermark: 'CANCELLED',
          content: this.documentDefinition.content,
          styles: this.documentDefinition.styles
        };
        const details = {
          reason: result.totext,
          contractImage: JSON.stringify(definition),
          contractLog: JSON.stringify(this.statusInfo),
          id: this.signRequestDetails.reportDetails.id,
          SID:this.authservice.getSID()
        };
        await this.updateSignRequestDetails(details, true, true);
        this.signRequestDetails = undefined;
      }
    });
  }

  updateSignRequestDetails(details, isCancelled, deleteRecord: boolean): Promise<void> {
    return new Promise(resolve => {
      this.updateSignRequestSubscription =
        this.contractService.updateSignRequest(details).subscribe(async () => {
          const requestId = this.signRequestDetails.signature_request.signature_request_id;
          const emailID=[];
          this.signRequestDetails.signature_request.signatures.forEach(signer => {
            emailID.push(signer.signer_email_address);  
          });
          // emailID = this.signRequestDetails.signature_request.signatures[0].signer_email_address;
          if (deleteRecord) {
            await this.cancelSignRequest(requestId,emailID.join(","), isCancelled);
          }
          resolve();
        });
    });
  }

  doManualSigned() {
    const formFields = MODEL_FIELDS.FILTER_USING_TEXT_FIELD;
    const dialogRef = this.dialog.open(FilterDialogModalComponent, {
      width: formFields.length === 1 ? '415px' : '507px',
      height: 'auto',
      data: {
        accept: 'Yes, Signed', reject: 'No',
        modalTitle: 'Reason For Manual Signature', formFields,
        description: 'Enter the reason for manual signature'
      }
    });

    this.logUserActivity(this.cancellationDetails.from + ' - Manual Signed', LOG_MESSAGES.CLICK);
    this.dialogCloseSubscription = dialogRef.afterClosed().subscribe(async result => {
      
      if (result !== undefined) {
        this.documentDefinition.content.push({
          text: '\n**This document has been manually signed',
          fontSize: 9,
          bold: true,
        });
        const definition = {
          content: this.documentDefinition.content,
          styles: this.documentDefinition.styles
        };
        const details = {
          reason: result.totext,
          fromUser: this.userService.getLoggedInUserName(),
          contractImage: JSON.stringify(definition),
          contractLog: JSON.stringify(this.statusInfo),
          id: this.signRequestDetails.reportDetails.id,
          SID:this.authservice.getSID()

        };
        await this.updateSignRequestDetails(details, false, false);
        this.getViewStatus(this.groupId);
        this.ngaugeService.toastrSuccess('Agreement updated successfully');
        // this.signRequestDetails = undefined;
      }
    });

  }

  callMailCompose() {
    const isComplete = this.signRequestDetails !== undefined &&
      this.signRequestDetails.signature_request.is_complete;
    const requestCreated =
      this.signRequestDetails !== undefined && isComplete !== true ? true : false;
    this.mailPDF.emit(requestCreated);
  }

  refreshStatus() {
    this.getViewStatus(this.groupId);
    this.logUserActivity(this.docFrom + '- Refresh Status', LOG_MESSAGES.CLICK);
  }

  getFinalCopy() {
    window.open(this.signRequestDetails.signature_request.files_url, '_blank').focus();
  }

  logUserActivity(from, value) {
    this.logService.logUserActivity(LOG_LEVELS.INFO, from, value);
  }

  ngOnDestroy() {
    this.unSubscribe(this.downloadContractSubscription);
    this.unSubscribe(this.statusSubscription);
    this.unSubscribe(this.dialogCloseSubscription);
    this.unSubscribe(this.sendNotifySubscription);
    this.unSubscribe(this.sendSignRequestSubscription);
    this.unSubscribe(this.cancelRequestSubscription);
    this.unSubscribe(this.updateSignRequestSubscription);
    this.unSubscribe(this.createContractSignSubscription);
    this.pdfDocument = null;
    this.groupId = null;
    this.groupAgreementAccountId = null;
    this.cancellationDetails = null;
    this.docFrom = null;
    this.mailPDF = null;
    this.signRequestDetails = null;
    this.statusCount = null;
    this.base64Image = null;
    this.statusInfo = null;
    this.contractService = null;
    this.ngaugeService = null;
    this.dialog = null;
    this.logService = null;
    this.newDocumentDefinition = null;
    this.cancelledText = null;
  }

  unSubscribe(subscription: Subscription) {
    if (subscription !== null && subscription !== undefined) {
      subscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/contracts/contracts.component.ts